import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortText',
})
export class ShortTextPipe implements PipeTransform {
  transform(text: string, numberOfCharacters = 30): string | null {
    if (!text) return null;
    return text.length > numberOfCharacters ? text.substring(0, numberOfCharacters) + '...' : text;
  }
}
